import Heading from '@amzn/meridian/heading';
import Row from '@amzn/meridian/row';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CoachingFormData } from '../../../api/CoachingForm/schema';
import { LegacyNote, Profile } from '../../../Types';
import DataState from '../../../Types/DataState';
import Page from '../../../Types/Page';
import CoachingHistory from '../DashboardTables/CoachingHistory';
import ContainerWrapper from './ContainerWrapper';

interface CoachingContainerProps {
  coachingNotesState: string;
  coachingHistoryState: string;
  coachingHistory: CoachingFormData[];
  coachingNotes: LegacyNote[];
  profile: Profile;
  profileState: string;
  refreshCoachingHistory: (
    queryVariablesCustomerCommentsNaws?: any,
    queryVariablesNawsCoachedNote?: any
  ) => void;
}

const CoachingContainer: React.FC<CoachingContainerProps> = ({
  coachingNotesState,
  coachingHistoryState,
  coachingNotes,
  coachingHistory,
  profile,
  profileState,
  refreshCoachingHistory,
}: CoachingContainerProps): React.ReactElement => {
  return (
    <>
      <Row spacingInset='400 none' spacing='none'>
        <Heading level={1} type='h400'>
          <FormattedMessage
            id='cs_perfportal_coachings'
            defaultMessage='Coachings'
          />
        </Heading>
      </Row>
      <ContainerWrapper
        loading={
          coachingHistoryState === DataState.LOADING ||
          coachingNotesState === DataState.LOADING
        }
        loaded={
          coachingNotesState === DataState.LOADED &&
          coachingHistoryState === DataState.LOADED
        }
        error={
          coachingNotesState === DataState.ERROR ||
          coachingHistoryState === DataState.ERROR
        }
      >
        <Row spacingInset='none none 400' spacing='none'>
          <CoachingHistory
            coachingHistory={coachingHistory}
            isTeam={false}
            legacyNotes={coachingNotes}
            profile={profile}
            profileState={profileState}
            page={Page.DASHBOARD}
            refreshCoachingHistory={refreshCoachingHistory}
          />
        </Row>
      </ContainerWrapper>
    </>
  );
};

export default CoachingContainer;
